import React, { useEffect } from 'react'
import { Routes, Route, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loginUser } from '../redux/features/userAuthSlice'
import { baseIP } from '../config/axios'
import NotFound from '../pages/404/NotFound'
import Home from '../pages/home/Home'
import EditCustomer from '../pages/edit-customer/EditCustomer'
import SearchCustomer from '../pages/search-customer/SearchCustomer'
import CustomerFullView from '../pages/full-view/CustomerFullView'
import BranchArea from '../pages/brach-area/BranchArea'
import Associates from '../pages/associates/Associates'
import WaSendStatusList from '../pages/wa-messages-send/WaSendStatusList'
import SpareList from '../pages/spare/SpareList'
import ServiceWorkList from '../pages/service-work/ServiceWorkList'
import ParentProductList from '../pages/products/ParentProductList'
import BundledComponentsList from '../pages/bundled-components/BundledComponentsList'
import ProductVariantList from '../pages/products/ProductVariantList'


function User() {
  const { user } = useSelector((state) => state.userAuth)
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch()
  let isAuthenticated = false

  if (user?.token) {
    isAuthenticated = true
  }

  useEffect(() => {
    const id = searchParams.get('id');
    if (!id && !user?._id) {
      window.location.href = `http://staff.alliancewatersolutions.com`
    } else if (id || user?._id) {
      dispatch(loginUser(id || user?._id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <Routes>
      {/* Home */}
      <Route path='/' element={<PrivateRoute element={<Home />} isAuthenticated={isAuthenticated} />} />
      <Route path='/customer/search' element={<PrivateRoute element={<SearchCustomer />} isAuthenticated={isAuthenticated} />} />
      <Route path='/customer/:cid/full-view' element={<PrivateRoute element={<CustomerFullView />} isAuthenticated={isAuthenticated} />} />

      {/* Production */}
      <Route path='/spares' element={<PrivateRoute element={<SpareList />} isAuthenticated={isAuthenticated} />} />
      <Route path='/service-works' element={<PrivateRoute element={<ServiceWorkList />} isAuthenticated={isAuthenticated} />} />
      <Route path='/bundled-components' element={<PrivateRoute element={<BundledComponentsList />} isAuthenticated={isAuthenticated} />} />
      <Route path='/parent-products' element={<PrivateRoute element={<ParentProductList />} isAuthenticated={isAuthenticated} />} />
      <Route path='/product-variants' element={<PrivateRoute element={<ProductVariantList />} isAuthenticated={isAuthenticated} />} />


      {user?.designation?.allow_origins?.includes('ControlNex') && <>
        <Route path='/customer/:cid/edit' element={<PrivateRoute element={<EditCustomer />} isAuthenticated={isAuthenticated} />} />

        {/* Post Office */}
        <Route path='/branch-area' element={<PrivateRoute element={<BranchArea />} isAuthenticated={isAuthenticated} />} />
        <Route path='/associates-list' element={<PrivateRoute element={<Associates />} isAuthenticated={isAuthenticated} />} />


        <Route path='/wa-message-send-list' element={<PrivateRoute element={<WaSendStatusList />} isAuthenticated={isAuthenticated} />} />
      </>}


      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

function PrivateRoute({ element, isAuthenticated }) {
  return isAuthenticated ? (
    <Routes>
      <Route path='/' element={element} />
    </Routes>
  ) : ""

}

export default User